module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators-2.2ae57c16.jpg";